<template>
  <PromomatsDocumentSelector
    v-show="state === 'SELECT'"
    :singleSelect="props.doc ? true : false"
    @next="state = 'IMPORT'"
    @close="emit('close')"
    v-model:selectedDocuments="selectedDocuments"
  />
  <PromomatsImport
    v-if="state === 'IMPORT'"
    :selectedDocuments="selectedDocuments"
    :doc="doc"
    @close="emit('close')"
    @success="emit('success')"
    @goBack="handleGoBack"
  />
</template>

<script lang="ts" setup>
import { ref, PropType } from "vue";
import { PMDoc } from "./PromomatsDocument";
import PromomatsDocumentSelector from "./PromomatsDocumentSelector.vue";
import PromomatsImport from "./PromomatsImport.vue";
import { WorkspaceDocumentFragment } from "@/graphql/operations";

const props = defineProps({
  doc: {
    type: Object as PropType<WorkspaceDocumentFragment>,
    required: false,
  },
});

const emit = defineEmits(["close", "success"]);

const state = ref<"SELECT" | "IMPORT">("SELECT");

const selectedDocuments = ref<PMDoc[]>([]);

const handleGoBack = (docs: PMDoc[]) => {
  selectedDocuments.value = docs;
  state.value = "SELECT";
};
</script>
